import React from "react";
import { render } from "react-dom";
import posed, { PoseGroup } from "react-pose";
import styled from "styled-components";

import shuffle from "./shuffle.js";

const Container = styled.div`
  
  display: flex;
  
  
`;

const Item = posed.li({
  enter: { opacity: 1 },
  exit: { opacity: 0 }
});

const StyledItem = styled(Item)`
  padding: 15px;
  list-style-type: none;
  color: black !important;
  border-radius: 5px;
  margin-right: 1em;
  margin-bottom: 10px;
  
  @media only screen and (max-width: 600px){
    width: 100%;
  }

`;

const colors=["#ddf3f5", "#fbc687", "#d291bc"];

const ItemList = ({ items }) => (
  <ul style={{marginLeft: `10%`}}>
    <PoseGroup>
      {items.map(item => <StyledItem style={{background: colors[(item.id-1)] , marginLeft: `0px`}} key={item.id}> <span style={{fontSize: `20px`, }} >{item.title}</span><br/><span  style={{fontSize: `20px`, }}>{item.text}</span></StyledItem>)}
    </PoseGroup>
  </ul>
);

class EducationList extends React.Component {
  state = {
    items: [
      { id: 1, text: "B. Tech Electrical Engg from I.I.T. ROORKEE ", title:"2022" },
      { id: 2, text: "Class 12th from A.V.M.D INSTITUTE (CBSE)", title:"2017"},
      { id: 3, text: "Class 10th from CHRIST THE KING INTER COLLEGE (ICSE)", title:"2015" },
      
    ]
  };

  _shuffle = () => {
    this.setState({ items: shuffle(this.state.items) });
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  componentDidMount() {
    this.interval = setInterval(this._shuffle, 2000);

    
  }

  render() {
    return (
      <Container>
        <ItemList background={colors[this.state.items.id]} items={this.state.items} />
      </Container>
    );
  }
}

export default EducationList;
